export default __webpack_public_path__ + "static/media/logoGO.7ca0a5c9.png";